import { MissionData } from '../blocks/mission'
import template from './templates/RJF06.rbxl'
import thumbnail1 from './thumbnails/RJF06/YellowBlock.png'
import thumbnail2 from './thumbnails/RJF06/BlueBlock.png'
import thumbnail3 from './thumbnails/RJF06/GreenBlock.png'
import thumbnail4 from './thumbnails/RJF06/BossAttack.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①きいろいブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②あおいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③みどりのかべ',
      thumbnail: thumbnail3,
    },
    {
      name: '④ボスのこうげき',
      thumbnail: thumbnail4,
    },
  ],
}

export default mission
